/**
 * A blocked month is waiting on an earlier one, which is not the same as its own
 * auto-reconciliation having failed, and recover blocks months that never ran one.
 */
export const reconciliationFailureHeading = (blocked: boolean) =>
  blocked ? 'Waiting on an earlier month' : 'Auto-reconciliation failed'

/** Names the month that can be worked now, not the next hop back. */
export const blockedRecoveryMessage = (
  earliestOpenMonth: string | null,
  currentMonth: string | null
) => {
  if (!earliestOpenMonth) {
    return 'An earlier month still needs to be reconciled. Start with the earliest open month, and this month unblocks as the months before it complete.'
  }
  const unblocks = currentMonth
    ? ` Start there, and ${currentMonth} unblocks as the months before it complete.`
    : ' Start there.'
  return `${earliestOpenMonth} is the earliest month that still needs to be reconciled.${unblocks}`
}

export const goToBlockedOnBooksLabel = (earliestOpenMonth: string | null) =>
  earliestOpenMonth
    ? `Go to ${earliestOpenMonth} books`
    : 'Go to earlier month books'
